import * as Sentry from "@sentry/react-native";

type identity = {
  email: string;
  username: string;
};

type sentryIdentificationProps = {
  clubName?: string;
  identity: identity;
};

export const identifySentryUser = ({
  clubName,
  identity,
}: sentryIdentificationProps) => {
  Sentry.setTag("club", clubName);
  Sentry.setUser(identity);
};
